// ProspectingOutputThread.jsx
import React from 'react';
import ProspectingOutput from '../Prospecting/ProspectingOutput';

const ProspectingOutputThread = ({ thread }) => {
  return (
    <ProspectingOutput
      campaignData={thread.data?.campaign}
      existingChatHistory={thread.data?.chat}
      existingCampaignName={thread.name}
      existingThreadId={thread.id}
      existingFormData={thread.data?.formInputs || thread.metadata || {}}
      isReadOnly={true}
      isThread={true}
      scrollToOutputOnMount={false}
    />
  );
};
 
export default ProspectingOutputThread;
